import React, { use, useEffect, useState } from 'react';
import { Menu } from './Menu';
import { Link } from "react-router-dom";
import TopHeader from "./firstTopHeader";
import { loadDocs } from "../../utils/utils"
import { $http } from "../../instance/axios.instance"

function header() {

    const [logo, setLogo] = useState("");

    useEffect(() => {
        async function fetchData() {
            try {
                const [court_logo] = await Promise.all([
                    $http.get("logos"),
                ]);
                if (court_logo) {
                    console.log("logo", court_logo.data.data[0].court_logo);
                    setLogo(court_logo.data.data[0].court_logo);
                }

            }
            catch (e) {
                console.log(e)
            }
        };
        fetchData();
    }, []);

    return (
        <>
            <header className="header-area">
                <TopHeader />
                <div className="navbar-area">
                    <div className="atorn-responsive-nav">
                        <div className="container">
                            <div className="atorn-responsive-menu">
                                <div className="logo">
                                    <Link to="/">
                                        <img src={loadDocs(logo)} className="logo1" alt="logo" style={{width: '80px', height: '80px'}} />
                                        <img src={loadDocs(logo)} className="logo2" alt="logo" style={{width: '80px', height: '80px'}} />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Menu />
                </div>
            </header>

            <div className="search-overlay">
                <div className="d-table">
                    <div className="d-table-cell">
                        <div className="search-overlay-layer"></div>
                        <div className="search-overlay-layer"></div>
                        <div className="search-overlay-layer"></div>

                        <div className="search-overlay-close">
                            <span className="search-overlay-close-line"></span>
                            <span className="search-overlay-close-line"></span>
                        </div>

                        <div className="search-overlay-form">
                            <form>
                                <input type="text" className="input-search" placeholder="Search here..." />
                                <button type="submit"><i className='las la-search'></i></button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default header